var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mask",attrs:{"id":"loading"}},[_c('div',{staticClass:"loader-inner ball-pulse"},[_c('div',{staticStyle:{"background":"#A35BFF"}}),_c('div',{staticStyle:{"background":"#882FF9"}}),_c('div',{staticStyle:{"background":"#D28EF9"}})])])
}]

export { render, staticRenderFns }